export default __webpack_public_path__ + "static/argo-17d2190c1d875019ea9498e19cc8cf82.png";